import { render } from "./Bind.vue?vue&type=template&id=f2c205a0"
import script from "./Bind.vue?vue&type=script&lang=js"
export * from "./Bind.vue?vue&type=script&lang=js"

import "./Bind.vue?vue&type=style&index=0&id=f2c205a0&lang=less"
script.render = render

export default script